import React from 'react';
import { GridContainer } from './OffersList.styles';
import OffersNotFound from '@/features/oferta/components/OffersNotFound';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import { Button } from '@/components/button';
import CardImage from '@/components/card/CardImage/CardImage';
import Link from '@/providers/Link';

export interface OffersListProps {
  offers?: OffersType;
}

// TODO:
//    1. Refactor move it from components to a top level List folder
//    2. Refactor move it from components to a top level List folder

const OffersList = ({ offers, ...props }: OffersListProps) => {
  if (!offers || !offers.length) {
    return <OffersNotFound />;
  }
  return (
    <GridContainer>
      {offers.map((offer, index) => (
        <CardFeatured key={offer.slug}>
          <CardImage image={offer.image} href={`/ofertas/${offer.slug}.html`} />
          <CardTitle as="h2">
            <Link href={`/ofertas/${offer.slug}.html`}>{offer.title}</Link>
          </CardTitle>
          <CardBody>{offer.excerpt}</CardBody>
          <CardFooter>
            <Button href={`/ofertas/${offer.slug}.html`} block>
              Mais Detalhes
            </Button>
          </CardFooter>
        </CardFeatured>
      ))}
    </GridContainer>
  );
};

export default OffersList;
